(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationDialogController', LabNotificationDialogController);

    LabNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LabNotification', 'Clinic'];

    function LabNotificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LabNotification, Clinic) {
        var vm = this;

        vm.labNotification = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.clinics = Clinic.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.labNotification.id !== null) {
                LabNotification.update(vm.labNotification, onSaveSuccess, onSaveError);
            } else {
                LabNotification.save(vm.labNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:labNotificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
